import api from './api';
import { KundeProfile, BuyOrderHistorikk } from '../types';
import { getAccessToken, clearTokens } from './shopifyAuth';

const KUNDE_URL = '/kunde';

// Logout — clear stored Shopify tokens
export const logoutUser = (): void => {
  clearTokens();
};

// Get authenticated user profile (Shopify-sourced: name, email, live store credit)
export const getCurrentUser = async (): Promise<KundeProfile> => {
  const response = await api.get<KundeProfile>(`${KUNDE_URL}/profil`);
  return response.data;
};

// Fetch order history for the authenticated user
export const getOrderHistory = async (): Promise<BuyOrderHistorikk[]> => {
  const response = await api.get<BuyOrderHistorikk[]>(`${KUNDE_URL}/ordrehistorikk`);
  return response.data;
};

// Check if a Shopify access token exists
export const isAuthenticated = (): boolean => {
  return getAccessToken() !== null;
};
